import { z } from 'zod';

/**
 * Messages a client may send over `/ws`. A browser can't set headers on a WebSocket, so the
 * access token comes in an `auth` message (again whenever it is renewed); `watch` then asks
 * for news of one of the player's games.
 */
export const WsClientMessage = z.discriminatedUnion('type', [
  z.object({ type: z.literal('ping') }),
  z.object({ type: z.literal('echo'), payload: z.unknown() }),
  z.object({ type: z.literal('auth'), token: z.string().min(1).max(8192) }),
  z.object({ type: z.literal('watch'), gameId: z.uuid() }),
  z.object({ type: z.literal('unwatch'), gameId: z.uuid() }),
]);
export type WsClientMessage = z.infer<typeof WsClientMessage>;

export const WsServerMessage = z.discriminatedUnion('type', [
  z.object({ type: z.literal('hello'), serverTime: z.string() }),
  z.object({ type: z.literal('pong') }),
  z.object({ type: z.literal('echo'), payload: z.unknown() }),
  z.object({ type: z.literal('authed') }),
  /**
   * A watched game is at `version`: sent on `watch`, then after every change to it, whoever
   * made it. The client reads the game again if it is behind.
   */
  z.object({ type: z.literal('game'), gameId: z.uuid(), version: z.int().nonnegative() }),
  z.object({ type: z.literal('error'), message: z.string() }),
]);
export type WsServerMessage = z.infer<typeof WsServerMessage>;
